export default {
  setLocations(state, value) {
    state.locations = value;
  },
  setLocationsFix(state, value) {
    state.locationsFix = value;
  },
  setLocationsROI(state, value) {
    state.locationsROI = value;
  },
  setLocationVisibile(state, value) {
    state.isVisible = value;
  },
  setSelectedLocation(state, value) {
    state.selectedLocation = value;
  },
  setLocationId(state, value) {
    state.locationId = value;
    state.selectLocationModal = false;
  },
  showHideSelectLocationModal(state, value) {
    state.selectLocationModal = value;
  },
  setDateRange(state, value) {
    state.dateRange = value;
  },
  setLocationsGroup(state, value) {
    state.locationsGroup = value;
  },
  setLocationsGroupFromDate(state, value) {
    state.locationsGroupFromDate = value;
  },
  showCreateDialog(state) {
    state.createDialogVisible = true;
  },
  hideCreateDialog(state) {
    state.createDialogVisible = false;
  },
  setLocationGroupId(state, value){
    state.locationGroupId = value;
  },
  setLocationByGroup(state, value){
    state.locationByGroupItem = value;
  }
};
